import React from "react";
import { Helmet } from "react-helmet";
const HelmetReact = ({ title }) => {
  return (
    <Helmet>
      <title>
       Meridian Consulting | {title} 
      </title>
      <meta
        name="description"
        content="Meridian Consulting brings to you cloud-agnostic solutions and managed services to scale your business practices."
      />
    </Helmet>
  );
};

export default HelmetReact;
